module.exports = __webpack_public_path__ + "img/3f_r_pizzala@2x.e26c6e77.jpg";